import { useCallback, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { CiExport } from "react-icons/ci";
import CsvDownloader from 'react-csv-downloader';
import { Badge, Button, Col, Form, Row, Table } from 'react-bootstrap';
import { FiRefreshCcw } from 'react-icons/fi';
import { fetchAllDataAPI, filterByParams } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';
import { numberMasking } from '../../utils/numberMasking';
import { numberFormat } from '../../utils/numberFormat';
import withAuth from '../../utils/withAuth';


const AllOrder = () => {
    const ref = useRef(null);
    const [order, setOrder] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const adminid = localStorage.getItem('admindata');
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 25;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = order.slice(firstIndex, lastIndex);
    const npage = Math.ceil(order.length / recordPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)
    const [filterstate, setFilterState] = useState([]);
    const [filterdealer, setFilterDealer] = useState([]);
    const [filtercourier, setFilterCourier] = useState([]);
    const [filtervalues, setFilterValue] = useState({});
    const [filtervalidated, setFilterValidated] = useState(false);


    useEffect(() => {
        if (adminid) {
            navigate("/all-orders")
            getAllOrders();
            getFilterStateDeliveryOrder();
        }
        else {
            navigate("/");
        }
    }, [adminid, navigate])

    const getAllOrders = useCallback(() => {
        setIsloading(true);
        fetchAllDataAPI ('account-get-all-order-data')
            .then((res) => {
                if (res.data.status === 1) {
                    setOrder(res.data.orders);
                } else {
                    setOrder([]);
                }
                setIsloading(false);
            })
            .catch(() => {
                setIsloading(false);
                toast.error("Error fetching orders");
            });
    }, []);

    const columns = [
        { id: 's_no', displayName: 'Serial Number' },
        { id: 'unique_no', displayName: 'Unique Number' },
        { id: 'order_no', displayName: 'Order Number' },
        { id: 'docket_no', displayName: 'AWB Number' },
        { id: 'product', displayName: 'Product' },
        { id: 'total_item', displayName: 'Total Item' },
        { id: 'customer_name', displayName: 'Customer Name' },
        { id: 'customer_mobile', displayName: 'Primary Mobile' },
        { id: 'order_alt_mobile', displayName: 'Alternate Mobile' },
        { id: 'customer_address', displayName: 'Address Line' },
        { id: 'customer_city', displayName: 'City' },
        { id: 'customer_state', displayName: 'State' },
        { id: 'customer_district', displayName: 'District' },
        { id: 'customer_postbox', displayName: 'Postal Code' },
        { id: 'order_post_office', displayName: 'Post Office' },
        { id: 'order_advance_amt', displayName: 'Order Advance Amount' },
        { id: 'grand_total', displayName: 'Grand Total' },
        { id: 'dealer_id', displayName: 'Dealer ID' },
        { id: 'total_balance', displayName: 'Total Balance' },
        { id: 'order_confirm_status', displayName: 'Order Status' },
        { id: 'shipping_status', displayName: 'Delivery Status' },
        { id: 'center_name', displayName: 'Center Name' },
        { id: 'agent_name', displayName: 'Agent Name' },
        { id: 'ocourier_name', displayName: 'Courier Name' },
        { id: 'order_confirm_to', displayName: 'Order Confirm To' },
        { id: 'created_date', displayName: 'Order Date' },
        { id: 'dispatch_date', displayName: 'Dispatch Date' },
        { id: 'delivery_date', displayName: 'Delivery Date' },
        { id: 'rec_amt_date', displayName: 'Recieve Amount Date' },
        { id: 'prepaid_received_amt', displayName: 'Prepaid Received Amount' },
        { id: 'cod_receive_amt', displayName: 'COD Received Amount' },
        { id: 'shipping_charge', displayName: 'Shipping Charge' },
        { id: 'total_disc', displayName: 'Total Discount' },
        { id: 'order_source_name', displayName: 'Chanel Name' },
        { id: 'order_language_name', displayName: 'Language Name' },
        { id: 'order_status', displayName: 'Order Status' },
        { id: 'order_remarks', displayName: 'Remarks' },
    ];
    const exportOrder = order.map((o, index) => ({
        s_no: index + 1,
        unique_no: o.cust_unique_number,
        order_no: o.order_number,
        docket_no: o.awb_number || '',
        product: `"${o.order_product?.map(prod => `${prod.p_name} x ${prod.p_qty}${prod.p_tsell_price === "0.00" ? ' (Free)' : ''}`).join(', ') || ''}"`,
        total_item: o.order_product.length,
        customer_name: o.order_name || '',
        customer_mobile: numberMasking(o.order_mobile) || '',
        order_alt_mobile: numberMasking(o.order_alt_mobile) || '',
        customer_address: `"${o.order_address || ''}"`,
        customer_city: o.order_city || '',
        customer_state: o.order_state || '',
        customer_district: o.order_city || '',
        customer_postbox: o.order_pincode || '',
        order_post_office: o.order_post_office || '',
        order_advance_amt: o.order_advance_amt || '',
        grand_total: o.grand_total || '',
        dealer_id: o.dealer_id || '',
        total_balance: o.total_balance || 0,
        shipping_status: o.shipping_status || '',
        order_confirm_status: o.order_confirm_status || '',
        center_name: o.center_name || '',
        agent_name: o.agent_name || '',
        ocourier_name: o.ocourier_name || '',
        order_confirm_to: o.order_confirm_to || '',
        created_date: o.created_date || '',
        dispatch_date: o.dispatch_date || '',
        delivery_date: o.delivery_date || '',
        rec_amt_date: o.rec_amt_date || '',
        prepaid_received_amt: o.prepaid_received_amt || '',
        cod_receive_amt: o.cod_receive_amt || '',
        shipping_charge: o.shipping_charge || '',
        total_disc: o.total_disc || '',
        order_source_name: o.order_source_name || '',
        order_language_name: o.order_language_name || '',
        order_status: o.shipping_status || '',
        order_remarks: o.order_remarks || '',
    }));

    const getFilterStateDeliveryOrder = () => {
        fetchAllDataAPI('dispatch-get-state-delivery-order-filter-data').then((res) => {
            if (res.data.status === 1) {
                setFilterState(...[res.data.state])
                setFilterDealer(...[res.data.dealer])
                setFilterCourier(...[res.data.courier])
            }
        })
    }
    const handleOrderFilter = async (event) => {
        event.preventDefault();
        setIsloading(true);
        const form = event.currentTarget;
    
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setIsloading(false);
            return;
        }
        try {
            const filterdata = {
                f_order_id: filtervalues.f_order_id,
                f_order_mobile: filtervalues.f_order_mobile,
                f_order_awb: filtervalues.f_order_awb,
                f_order_state: filtervalues.f_order_state,
                f_order_sdate: filtervalues.f_order_sdate,
                f_order_edate: filtervalues.f_order_edate,
                f_order_dstatus: filtervalues.f_order_dstatus,
                f_order_dealer: filtervalues.f_order_dealer,
                f_order_courier: filtervalues.f_order_courier,
                f_order_confirmto: filtervalues.f_order_confirmto,
                f_get_order_by: filtervalues.f_get_order_by,
            };
    
            const res = await filterByParams('account-filter-order-data', filterdata);
    
            if (res.data.status === 1 && res.data.orders.length > 0) {
                setOrder(res.data.orders);
            } 
            else {
                setOrder([]);
            }
        } 
        catch (error) {
            toast.error("Something went wrong!!");
            setOrder([]);
        } 
        finally {
            setIsloading(false);
            setFilterValidated(true);
        }
    };
    
    const resetOrder = () => {
        const resetFilters = {
            f_order_id: "",
            f_order_mobile: "",
            f_order_awb: "",
            f_order_state: "",
            f_order_sdate: "",
            f_order_edate: "",
            f_order_dstatus: "",
            f_order_dealer: "",
            f_order_courier: "",
            f_order_confirmto: "",
            f_get_order_by: "",
        };
    
        setFilterValue(resetFilters);
        if (ref.current) {
            ref.current.reset();
        }
        getAllOrders();
    };
    
    let handleFilterInputs = e => {
        setFilterValue({
            ...filtervalues,
            [e.target.name]: e.target.value,
        });
    };


    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR:ALL ORDERS</title>
            </Helmet>
            <ContentWrapper>
                <div className="page-wrapper breadcum">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center">
                        <div className="d-flex">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">ALL ORDERS</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="customFilter">
                        <div className="card">
                            <div className="filterBodys">
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <Form ref={ref} noValidate validated={filtervalidated} onSubmit={handleOrderFilter} method="GET" className="p-2">
                                            <Row className="mb-3">
                                                <Form.Group as={Col} md="3" controlId="validationCustom01">
                                                    <Form.Label>Order ID</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search By Order ID"
                                                        name="f_order_id"
                                                        onChange={handleFilterInputs}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom01">
                                                    <Form.Label>Mobile Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search By Mobile Number"
                                                        name="f_order_mobile"
                                                        onChange={handleFilterInputs}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom01">
                                                    <Form.Label>Search By AWB</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search By AWB"
                                                        name="f_order_awb"
                                                        onChange={handleFilterInputs}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Search By State</Form.Label>
                                                    <Form.Select
                                                        placeholder="Gender Name"
                                                        name="f_order_state"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Select State</option>
                                                        {filterstate?.map((filterstate, index) => (
                                                            <option key={index} value={filterstate?.state_name}>{filterstate?.state_name}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom01">
                                                    <Form.Label>Start Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter the Mobile Number"
                                                        name="f_order_sdate"
                                                        onChange={handleFilterInputs}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom01">
                                                    <Form.Label>End Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter the Mobile Number"
                                                        name="f_order_edate"
                                                        onChange={handleFilterInputs}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Search By Delivery Status</Form.Label>
                                                    <Form.Select
                                                        name="f_order_dstatus"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Select Delivery Status</option>
                                                        <option value="Delivered">Delivered</option>
                                                        <option value="Canceled">Canceled</option>
                                                        <option value="Returned">Returned</option>
                                                        <option value="Undelivered">Undelivered</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Search By Dealer</Form.Label>
                                                    <Form.Select
                                                        name="f_order_dealer"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Select Dealer</option>
                                                        {filterdealer?.map((filterdealer, index) => (
                                                            <option key={index} value={filterdealer?.dealer_code}>{filterdealer?.dealer_code}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Search By Courier</Form.Label>
                                                    <Form.Select
                                                        name="f_order_courier"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Select Courier</option>
                                                        {filtercourier?.map((filtercourier, index) => (
                                                            <option key={index} value={filtercourier?.courier_name}>{filtercourier?.courier_name}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Search By Confirm To</Form.Label>
                                                    <Form.Select
                                                        name="f_order_confirmto"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Search By Confirm To</option>
                                                        {filtercourier?.map((filtercourier, index) => (
                                                            <option key={index} value={filtercourier?.courier_name}>{filtercourier?.courier_name}</option>
                                                        ))}
                                                        {filterdealer?.map((filterdealer, index) => (
                                                            <option key={index} value={filterdealer?.dealer_code}>{filterdealer?.dealer_code}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" controlId="validationCustom10">
                                                    <Form.Label>Get Order By</Form.Label>
                                                    <Form.Select
                                                        name="f_get_order_by"
                                                        onChange={handleFilterInputs}>
                                                        <option value="">Select Order By</option>
                                                        <option value="Status Date">Dispatch Date</option>
                                                        <option value="Order Date">Order Date</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-2">
                                                <Form.Group as={Col} md="3" className="d-flex">
                                                    <Button style={{ color: "#fff", border: "none", fontWeight:"600",borderRadius:"3px" }} type="submit" className="btn btn-sm btn-primary">Submit</Button>
                                                    <span style={{ marginLeft: "10px", color: "#fff", border: "none", fontWeight:"600",borderRadius:"3px" }} onClick={resetOrder} className="btn btn-sm btn-secondary"><FiRefreshCcw /> Refresh</span>
                                                    <CsvDownloader filename="All Orders"
                                                        extension=".csv"
                                                        datas={exportOrder}
                                                        columns={columns}
                                                        className="btnorderfilter"
                                                    >
                                                        <span style={{ color: "#fff", border: "none", fontWeight:"600",borderRadius:"3px" }} className="btn btn-info btn-sm"><CiExport style={{marginRight:"5px",color:"#fff"}} /> Export</span>
                                                    </CsvDownloader>
                                                </Form.Group>
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card tablecard mt-2" style={{marginBottom:"50px"}}>
                        <div className="table-responsive">
                            <Table className="table-sm table-fixeds" responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: '100px', position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>
                                            #
                                        </th>
                                        <th style={{ width: '100px', position: 'sticky', left: '22px', background: 'white', zIndex: 1 }}>Order No.</th>
                                        <th style={{ width: '20%' }}>Name</th>
                                        <th style={{ width: '20%' }}>Mobile</th>
                                        <th style={{ width: '20%' }}>Assigned Dealer</th>
                                        <th style={{ width: '20%' }}>AWB Number</th>
                                        <th style={{ width: '20%' }}>Courier</th>
                                        <th style={{ width: '20%' }}>Product Name</th>
                                        <th style={{ width: '20%' }}>Total Amount</th>
                                        <th style={{ width: '20%' }}>Adv Amount</th>
                                        <th style={{ width: '20%' }}>Balance Amount</th>
                                        <th style={{ width: '20%' }}>COD Rec Amt</th>
                                        <th style={{ width: '20%' }}>Prepaid Rec Amt</th>
                                        <th style={{ width: '20%' }}>Disctrict</th>
                                        <th style={{ width: '20%' }}>City</th>
                                        <th style={{ width: '20%' }}>State</th>
                                        <th style={{ width: '20%' }}>Pincode</th>
                                        <th style={{ width: '20%' }}>Order Date</th>
                                        <th style={{ width: '20%' }}>Dispatch Date</th>
                                        <th style={{ width: '20%' }}>Delivery Date</th>
                                        <th style={{ width: '20%' }}>Delivery Status</th>
                                        <th style={{ width: '20%' }}>Confirm TO</th>
                                        <th style={{ width: '20%' }}>Center Name</th>
                                        <th style={{ width: '20%' }}>Agent Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <>
                                            {[...Array(10)].map((_, index) => (
                                                <tr key={index}>
                                                    {Array.from({ length: 23 }).map((_, index) => (
                                                        <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </>
                                    ) : records.length ? (
                                        records.map((record, index) => (
                                            <tr key={index}>
                                                <td style={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>
                                                    <div className="d-flex" style={{ gap: "3px" }}>
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td style={{ position: 'sticky', left: '22px', background: 'white', zIndex: 1 }}>
                                                    <Badge bg="success">{record?.order_number}</Badge>
                                                </td>
                                                <td>{record?.order_name}</td>
                                                <td>{numberMasking(record?.order_mobile)}</td>
                                                <td>{record?.dealer_id}</td>
                                                <td>{record?.awb_number}</td>
                                                <td>{record?.ocourier_name}</td>
                                                <td>
                                                    {record?.order_product?.map((product, index) => (
                                                        product?.p_tsell_price === "0.00" ? (
                                                            <p className="text-danger" key={index}>{product?.p_name} x {product?.p_qty} <span>Free</span></p>
                                                        ) : (
                                                            <p key={index}>{product?.p_name} x {product?.p_qty}</p>
                                                        )
                                                    ))}
                                                </td>
                                                <td>{numberFormat(record?.grand_total)}</td>
                                                <td>{numberFormat(record?.order_advance_amt)}</td>
                                                <td>{numberFormat(record?.total_balance)}</td>
                                                <td>{numberFormat(record?.cod_receive_amt)}</td>
                                                <td>{numberFormat(record?.prepaid_received_amt)}</td>
                                                <td>{record?.order_city}</td>
                                                <td>{record?.order_city}</td>
                                                <td>{record?.order_state}</td>
                                                <td>{record?.order_pincode}</td>
                                                <td>{record?.created_date}</td>
                                                <td>{record?.dispatch_date}</td>
                                                <td>{record?.delivery_date}</td>
                                                <td>{record?.shipping_status}</td>
                                                <td>{record?.order_confirm_to}</td>
                                                <td>{record?.center_name}</td>
                                                <td>{record?.agent_name}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="text-center" colSpan={23}>Data not found...</td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th style={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>#</th>
                                        <th style={{ position: 'sticky', left: '22px', background: 'white', zIndex: 1 }}>Order No.</th>
                                        <th style={{ width: '20%' }}>Name</th>
                                        <th style={{ width: '20%' }}>Mobile</th>
                                        <th style={{ width: '20%' }}>Assigned Dealer</th>
                                        <th style={{ width: '20%' }}>AWB Number</th>
                                        <th style={{ width: '20%' }}>Courier</th>
                                        <th style={{ width: '20%' }}>Product Name</th>
                                        <th style={{ width: '20%' }}>Total Amount</th>
                                        <th style={{ width: '20%' }}>Adv Amount</th>
                                        <th style={{ width: '20%' }}>Balance Amount</th>
                                        <th style={{ width: '20%' }}>COD Rec Amt</th>
                                        <th style={{ width: '20%' }}>Prepaid Rec Amt</th>
                                        <th style={{ width: '20%' }}>Disctrict</th>
                                        <th style={{ width: '20%' }}>City</th>
                                        <th style={{ width: '20%' }}>State</th>
                                        <th style={{ width: '20%' }}>Pincode</th>
                                        <th style={{ width: '20%' }}>Order Date</th>
                                        <th style={{ width: '20%' }}>Delivery Date</th>
                                        <th style={{ width: '20%' }}>Delivery Status</th>
                                        <th style={{ width: '20%' }}>Confirm TO</th>
                                        <th style={{ width: '20%' }}>Center Name</th>
                                        <th style={{ width: '20%' }}>Agent Name</th>
                                    </tr>
                                </tfoot>
                            </Table>
                            <nav className="pagination-container mt-2">
                                <ul className="pagination align-items-center">
                                    <li className="total-orders ml-2">Total Orders: {order.length}</li>
                                </ul>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <a href="#" className="page-link" onClick={perPage}>Previous</a>
                                    </li>
                                    {numbers.map((n, i) => {
                                        if (
                                            n === 1 ||
                                            n === npage ||
                                            n === currentPage ||
                                            (n >= currentPage - 2 && n <= currentPage + 2)
                                        ) {
                                            return (
                                                <li className={`page-item ${currentPage === n ? 'active' : ''}`} key={i}>
                                                    <a href="#" className="page-link" onClick={() => changePage(n)}>{n}</a>
                                                </li>
                                            );
                                        }
                                        if (
                                            (n === currentPage - 3 && currentPage > 4) ||
                                            (n === currentPage + 3 && currentPage < npage - 3)
                                        ) {
                                            return (
                                                <li className="page-item disabled" key={i}>
                                                    <span className="page-link">...</span>
                                                </li>
                                            );
                                        }

                                        return null;
                                    })}
                                    <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}>
                                        <a href="#" className="page-link" onClick={nextPage}>Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default withAuth(AllOrder)